// removed by extract-text-webpack-plugin
module.exports = {"White":"#FFFFFF","ArrowHeight":"30px","arrow":"G0423aa","arrow--top":"G183dfe","arrow--bottom":"G30a2bb","arrow--left":"Gd83c24","arrow--right":"G9f1b38"};